import React from "react";
import NoContent from "../../../components/NoContent/NoContent";

interface NoOrdersProps {
  shopUrl: string;
}

const NoOrders = ({ shopUrl }: NoOrdersProps) => {
  return (
    <NoContent
      imageSrc="/assets/images/no-orders.svg"
      imageAlt="No orders illustration"
      title="You Haven't Placed Any Orders Yet"
      description={
        <>
          When you order medications or supplies through <br />
          the GoodVets Online Pharmacy, they&apos;ll appear <br />
          here so you can track and reorder them anytime.
        </>
      }
      buttonText="Place an Order"
      buttonUrl={shopUrl}
    />
  );
};

export default NoOrders;
